if (!customElements.get('rs-announcement-animate')) {
  customElements.define('rs-announcement-animate', class extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('.rs-ann-animate__item'));
      this._index = 0;
      this._speed = parseInt(this.dataset.speed) || 7000;

      if (this._items.length === 0) return;

      // Show the first item immediately
      this._enter(0);

      // Only cycle if there is more than one item
      if (this._items.length > 1) {
        this._timer = setInterval(() => this._advance(), this._speed);
      }
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }

    _enter(index) {
      this._items[index].classList.remove('rs-ann--exiting');
      this._items[index].classList.add('rs-ann--entering');
    }

    _exit(index) {
      this._items[index].classList.remove('rs-ann--entering');
      this._items[index].classList.add('rs-ann--exiting');
    }

    _advance() {
      const outgoing = this._index;
      this._index = (this._index + 1) % this._items.length;

      this._exit(outgoing);

      // Wait for exit animation (350ms) before entering the next item
      setTimeout(() => {
        this._items[outgoing].classList.remove('rs-ann--exiting');
        this._enter(this._index);
      }, 350);
    }
  });
}
